import React, { useEffect, useState } from 'react';
import { Download, X, Share } from 'lucide-react';
import { useT } from '../context/LanguageContext';

const DISMISS_KEY = 'mc-pwa-install-dismissed';

const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const PWAInstallPrompt = () => {
  const { t } = useT();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);

    // iOS Safari fires no beforeinstallprompt — show manual hint after a short delay.
    let t;
    if (isIos()) {
      t = setTimeout(() => { setIosHint(true); setShow(true); }, 1500);
    }
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); if (t) clearTimeout(t); };
  }, []);

  if (!show) return null;

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, '1'); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* noop */ }
    setDeferred(null);
    dismiss();
  };

  return (
    <div data-testid="pwa-install-banner" style={{
      position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 2000,
      background: '#0f172a', color: '#fff', borderRadius: 12, padding: '12px 14px',
      display: 'flex', alignItems: 'center', gap: 12, maxWidth: 460, margin: '0 auto',
      boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
    }}>
      <div style={{ width: 38, height: 38, borderRadius: 9, background: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Download size={20} />
      </div>
      <div style={{ flex: 1, fontSize: 13, lineHeight: 1.45 }}>
        {iosHint ? (
          <>{t('Installeer')} <b>MonteurCentraal</b>: {t('tik op')} <Share size={13} style={{ verticalAlign: 'middle' }} /> <b>{t('Deel')}</b> {t('en kies')} <b>"{t('Zet op beginscherm')}"</b>.</>
        ) : (
          <>{t('Installeer')} <b>MonteurCentraal</b> {t('als app voor sneller werken op je telefoon of pc.')}</>
        )}
      </div>
      {!iosHint && (
        <button data-testid="pwa-install-btn" onClick={install} style={{
          background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8,
          padding: '9px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', minHeight: 40,
        }}>{t('Installeren')}</button>
      )}
      <button data-testid="pwa-install-dismiss" onClick={dismiss} aria-label={t('Sluiten')} style={{
        background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 6, display: 'flex',
      }}><X size={18} /></button>
    </div>
  );
};
